export enum IndicatorChartTypeEnums {
  donut = 'donut',
  bar = 'bar',
}
